.container{padding:2rem;padding-bottom:0}.container .label{font-family:Roboto,Helvetica Neue,sans-serif;font-weight:400;font-size:14px;line-height:100%;letter-spacing:0%;margin-bottom:.5rem}
/*# sourceMappingURL=edit-message-modal.component-325YRUZU.css.map */
